var map = {
	"./ai.png": "lB7j",
	"./bmp.png": "Uy3F",
	"./cad.png": "y8bI",
	"./css.png": "lNmf",
	"./doc.png": "tdLa",
	"./gif.png": "FUq3",
	"./html.png": "lJSe",
	"./jpg.png": "vdD3",
	"./js.png": "Umq8",
	"./pdf.png": "iBrf",
	"./png.png": "HHtf",
	"./ppt.png": "78m4",
	"./psd.png": "uUAe",
	"./txt.png": "uDdy",
	"./unknown.png": "P3Hw",
	"./xls.png": "o6SX",
	"./zip.png": "6VoE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5moY";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon ^\.\/.*$
// module id = 5moY
// module chunks = 1